export enum RolesEnum {
    Admin = <any>'Admin',
    Office = <any>'Office',
    Hausdienst = <any>'Hausdienst',
    Hspl = <any>'HSPL',
    Trainingsleiter = <any>'Trainingsleiter'
}
